// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from "./store";
import router from './router'

// 引入Sentry
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import { BrowserTracing } from '@sentry/tracing';

// 初始化Sentry
Sentry.init({
  dsn: 'https://bbb4775f4e46ca09ad85655d689fa3ac@df-sentry.twyfordtile.com/14',
  environment: process.env.SENTRY_ENV,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    new VueIntegration({
      Vue,
      router,
      attachProps: true,
      logErrors: true
    }),
    new BrowserTracing(),
  ],
  tracesSampleRate: 1.0,
});

import {checkBrowserSupports} from './utils/browser';
import utils from './utils';
import cache from './utils/cache';
import apis from './request/apis';

import './assets/style/index.scss';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './vant';
import './createApi';
import FBSignInButton from 'vue-facebook-signin-button'
import VueMatomo from 'vue-matomo'
// import VueGtm from 'vue-gtm'
// import Vconsole from 'vconsole'

import i18n from './VueI18n';
//引入svg
import './icons';
// 全局注册组件
import './components/common';

checkBrowserSupports()

Vue.use(ElementUI);
Vue.use(FBSignInButton);
Vue.use(VueMatomo, {
  host: 'https://matomo.kedaceramics.com/matomo', // 你自己的matomo地址
  siteId: 1,//siteId值，这个值页需要去matomo上去申请
  // 根据router自动注册，需要注意的是如果有路由传值值太长的话matomo会监听不到并报414，就不能使用此方法了。解决：app.vue监听路由
  router: router,
  // 是否需要在发送追踪信息之前请求许可，默认false
  requireConsent: false,
  enableLinkTracking: true,
  // 是否追踪初始页面，默认true
  trackInitialView: false,
  // 最终的追踪js文件名，matomo版本比较老，使用的是piwik，现在新版本的话此值为matomo
  trackerFileName: 'matomo',
  debug: false
});
// const vConsole = new Vconsole();

// Vue.use(VueGtm,{
//   id:'GTM-PVQ9H9VY',
//   defer:false,
//   enabled: true,
//   debug:false,
//   vueRouter:router,
//   trackOnNextTick:false
// })

Vue.prototype.$store = store;
Vue.prototype.$apis = apis;
Vue.prototype.$cache = cache;
Vue.prototype.$utils = utils;
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js